import { useEffect, useState, useRef } from "react";
import { trans } from "utils/helpers";
import { getBpmnTaskApi } from "./api";
import { setTimeout } from "timers";
import { SubMenu } from "../SubMenu/SubMenu";

interface BpmnTaskPropsType {
  label?: string;
  processId?: string;
  hasBorder?: boolean;
  required?: boolean;
  value?: string;
  mode?: string;
  resetForm?: any;
  Change?: (e) => void;
  setBpmnTask?: (e) => void;
  displayKey?: string; // کلید برای نمایش در حالت object
  returnFullObject?: boolean; // برای برگرداندن کل object
}

export const BpmnTask = ({
  processId,
  label,
  hasBorder,
  value,
  mode,
  required,
  resetForm,
  Change,
  setBpmnTask,
  displayKey = "Name", // مقدار پیش‌فرض برای نمایش
  returnFullObject = false,
}: BpmnTaskPropsType) => {
  const [BpmnTask, setBpmnTasks] = useState<any>();
  const [valueName, setValueName] = useState<any>();
  const [flag, setFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [validat, setValidat] = useState(false);
  const [rquird, setRquird] = useState(false);
  const [activeId, setactiveId] = useState<any>();
  const inputRef = useRef<any>();
  const inputIdRef = useRef<any>();
  const BpmnTaskRef = useRef<any>(BpmnTask);
  const activeIdRef = useRef<any>(activeId);
  const ShowRef = useRef<any>(show);
  const validRef = useRef<any>(false);

  // تابع کمکی برای استخراج مقدار نمایشی
  const getDisplayValue = (item: any): string => {
    if (typeof item === "string" || typeof item === "number") {
      return String(item);
    } else if (typeof item === "object" && item !== null) {
      // اگر displayKey مشخص شده، از آن استفاده کن
      if (displayKey && item[displayKey]) {
        return String(item[displayKey]);
      }
      // در غیر این صورت، اولین مقدار string/number را پیدا کن
      const firstStringValue = Object.values(item).find(
        (val) => typeof val === "string" || typeof val === "number"
      );
      return firstStringValue ? String(firstStringValue) : JSON.stringify(item);
    }
    return "";
  };

  // تابع کمکی برای استخراج داده کامل
  const getFullData = (item: any, id: string): any => {
    if (typeof item === "string" || typeof item === "number") {
      return { Id: id, Name: String(item) };
    } else if (typeof item === "object" && item !== null) {
      return { Id: id, ...item };
    }
    return { Id: id, Name: "" };
  };

  async function getBpmnTaskListAsync(search, id) {
    try {
      const res = await getBpmnTaskApi(search, id, processId);
      if (id && res[id]) {
        const displayValue = getDisplayValue(res[id]);
        setValeu(displayValue, id, res[id]);
        setValueName(displayValue);
      }
      setBpmnTasks({ ...res });
      BpmnTaskRef.current = res;
      setFlag(!flag);
    } catch (err: any) {}
  }

  const Auto = (e) => {
    validRef.current = false;
    setValidat(false);
    setRquird(false);
    getBpmnTaskListAsync(e.target.value, "");
    setFlag(!flag);
  };

  const CheckBpmnTask = async (e) => {
    setTimeout(() => {
      if (!validRef.current) {
        if (BpmnTask != undefined && Object.values(BpmnTask).length == 1) {
          const firstKey = Object.keys(BpmnTask)[0];
          const firstValue = BpmnTask[firstKey];
          const displayValue = getDisplayValue(firstValue);
          setValeu(displayValue, firstKey, firstValue);
          e.target.setCustomValidity("");
        } else {
          if (inputRef.current) {
            setValeu(null, null, null);
          }
          if (
            inputRef?.current?.value.length > 0 &&
            inputRef?.current?.value != ""
          ) {
            e.target.setCustomValidity(
              trans("Msg_Validation_ValueIsIncorrect")
            );
            setValidat(true);
            e.target.reportValidity();
          }
          setBpmnTask && setBpmnTask(null);
        }
      }
    }, 200);
  };

  const setValeu = (newValue: string | null, id: string | null, fullData?: any) => {
    if (inputIdRef != null && inputIdRef.current != null) {
      validRef.current = true;
      
      if (newValue !== null && id !== null) {
        inputRef.current.value = newValue;
        inputIdRef.current.value = id;
        
        // تصمیم‌گیری برای ارسال داده
        const dataToSend = returnFullObject && fullData 
          ? getFullData(fullData, id)
          : newValue;
        
        ((value == null && id) || id != value)
          ? Change && Change({ person: dataToSend })
          : Change && Change({ person: null });
        
        setBpmnTask && setBpmnTask({
          Value: newValue,
          Id: id,
          ...(returnFullObject && fullData ? { ...fullData } : {})
        });
      } else {
        inputRef.current.value = "";
        inputIdRef.current.value = "";
        Change && Change({ person: null });
        setBpmnTask && setBpmnTask(null);
      }
      
      BpmnTaskRef.current = null;
      setBpmnTasks(null);
      setFlag(!flag);
      inputRef.current.setCustomValidity("");
      setValidat(false);
    }
  };

  useEffect(() => {
    if (value) {
      getBpmnTaskListAsync(null, value);
    } else if (value == null) {
      setValueName(null);
    }
  }, [value]);

  useEffect(() => {
    if (show) {
      document.body.addEventListener("click", clickToclose);
    }
    return () => {
      document.body.removeEventListener("click", clickToclose);
    };
  }, [show]);

  function clickToclose(e) {
    let input = document.querySelector("#browserBpmnTaskId");
    if (e.target.id !== input?.id) {
      setShow(false);
    }
  }

  // تبدیل BpmnTask به فرمت مناسب برای SubMenu
  const getSubMenuOptions = () => {
    if (!BpmnTask) return null;
    
    const options = {};
    Object.keys(BpmnTask).forEach((key) => {
      options[key] = getDisplayValue(BpmnTask[key]);
    });
    return options;
  };

  return (
    <>
      <div className="text-box">
        <label htmlFor="browser" className="text-box__label">
          {trans("tasktitle")}
        </label>
        {required && (
          <span className="text-box__required-sign-for-label text-danger">
            *
          </span>
        )}
        <input
          required={required}
          defaultValue={value && value}
          name="BpmnTaskId"
          className="d-none"
          ref={inputIdRef}
        />
        <input
          required={required}
          onBlur={CheckBpmnTask}
          defaultValue={valueName}
          autoComplete="off"
          onFocus={(e) => {
            Auto(e);
            setShow(true);
          }}
          ref={inputRef}
          list="BpmnTaskList"
          name="browser"
          className="text-box__box form-control "
          id={"browserBpmnTaskId"}
          onMouseDown={(e) => e.stopPropagation()}
          onChange={Auto}
          disabled={mode == "view" ? true : false}
        />
        {show && (
          <SubMenu
            onClick={(displayValue, id) => {
              const fullData = BpmnTask?.[id];
              setValeu(displayValue, id, fullData);
            }}
            options={getSubMenuOptions()}
            onHide={() => {
              setShow(false);
            }}
          />
        )}
        <div className="text-box__msg-wrapper">
          {required && (
            <span
              className={`${
                validat ? "show-msg" : "hide-msg"
              } text-box__required-msg text-danger`}
            >
              {trans("Msg_Validation_ValueIsIncorrect")}
            </span>
          )}
          {required && (
            <span
              className={`${
                rquird ? "show-msg" : "hide-msg"
              } text-box__required-msg text-danger`}
            >
              {trans("Msg_Validation_ValueIsRequired", [""])}
            </span>
          )}
        </div>
      </div>
    </>
  );
};